import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Button, Typography } from '@material-ui/core';

import Title from '../../../components/Title';
import { unsubscribeUserLaunched } from '../../App/reducer';

const ConfirmUnsubscribeModal = ({ payload }) => {
  const dispatch = useDispatch();

  const { userId } = useSelector((state) => ({
    userId: state.getIn(['app', 'userDynamo', 'user', 'id'])
  }));
  const handleUnsubscribe = () => {
    dispatch(unsubscribeUserLaunched({ ...payload, userId }));
  };

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      style={{ padding: 20 }}
    >
      <Title title="Confirmer la désinscription" color="secondary" />
      <Typography variant="body1" style={{ marginTop: 20, marginBottom: 20 }}>
        Êtes-vous sûr de vouloir vous désinscrire ? Cette action est irréversible.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleUnsubscribe}
      >
        Confirmer la désinscription
      </Button>
    </Grid>
  );
};

export default ConfirmUnsubscribeModal;
